
$.fn.getHashFromUrl = function(url) {
    return $("<a />").attr("href", url)[0].hash.replace(/^#/, "");
}




$(document).ready(function() {

    var mobileNavActive = false;

    var breakpoint_xs = $('html').css('--breakpoint-xs');
    var breakpoint_xd = $('html').css('--breakpoint-xd');
    var breakpoint_md = $('html').css('--breakpoint-md');
    var breakpoint_lg = $('html').css('--breakpoint-lg');
    var breakpoint_xl = $('html').css('--breakpoint-xl');
    var breakpoint_xxl = $('html').css('--breakpoint-xxl');
    var color_main = $('html').css('--color-main');
    var color_secondary = $('html').css('--color-secondary');

    // Header Mobile Menu Button

    $('.toggle-nav-btn').on('click', function(){
        if(!mobileNavActive) {
            $('html').addClass('mobile-nav-active');
            mobileNavActive = true;
        } else{
            $('html').removeClass('mobile-nav-active');
            mobileNavActive = false;
        }
    });

    // Hero header images

    var resizeId;
    $(window).resize(function() {
        clearTimeout(resizeId);
        resizeId = setTimeout(function(){
            $('.section-hero-slide').removeClass('loading-complete');
            $(".section-hero-slide").each(function( index ) {
                $(this).loadSectionImage();
            });
        }, 500);
    });

    $(".section-hero-slide").each(function( index ) {
        $(this).loadSectionImage();
    });

    // Header Menu Smooth Scrolling

    $('#nav-main a[href^="#"]').on('click',function(e){
        e.preventDefault();
        if(mobileNavActive){
            $('html').removeClass('mobile-nav-active');
            mobileNavActive = false;
        }
        $('#nav-main .nav-item').removeClass('current');
        $(this).closest('.nav-item').addClass('current');
        var navHeight = $('#nav-main').height();
        var anchor = $(this).attr('href');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    $('.btn-scroll').on('click',function(e){
        e.preventDefault();
        var navHeight = $('#nav-main').height();
        var anchor = $(this).attr('href');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Content Buttons Smooth Scrolling

    $('.btn-anchor').on('click',function(e){
        e.preventDefault();
        var navHeight = $('#main-nav').height();
        var anchor = $(this).attr('href');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Content Buttons Smooth Scrolling
    // Form Buttons with autoselect form option

    $('.btn-anchor-form').on('click',function(e){
        e.preventDefault();
        var navHeight = $('.nav-main').height();
        var anchor = $(this).attr('href');
        var form = $(this).data('form-id');
        var selected = $(this).data('selected');
        var option = 'option[data-selected="'+selected +'"]';
        $('#'+ form).find('option').prop("selected", false);
        $('#'+ form).find(option).prop("selected", true); //$('#'+ form).find(option).attr('selected','selected');
        $('html, body').animate({scrollTop: $(anchor).offset().top - navHeight }, 'slow');
    });

    // Toogle Buttons Footer

    $('.toggle-btn').on('click',function(e){
        e.preventDefault();

        $('.toggle').removeClass('is-active');
        $('.toggle-btn').removeClass('is-active');

        $(this).toggleClass('is-active');
        var anchor = $(this).attr('href');
        $(anchor).toggleClass('is-active');

        $('html, body').animate({scrollTop: $(anchor).offset().top }, 'slow');
    });


    // Responsive Navigation

    $('#nav-responsive a').on('click', function(e){
        e.preventDefault();
        var viewportHeight = $(window).height();
        var viewportWidth = $('html').css('--breakpoint-' + $(this).data('size'));
        window.open(window.location.href, "_blank", "width="+viewportWidth+",height="+viewportHeight+"");
    });

});


